import "./ProductPageSkeleton.css";

function Skeleton({ className = "" }) {
    return (
        <div className={`skeleton ${className}`}>
        </div>
    );
}

function ProductGallerySkeleton() {
    return (
        <div className="product-gallery-skeleton">

            <Skeleton className="gallery-main-image" />

            <div className="gallery-thumbnails">

                {[1, 2, 3, 4].map((item) => (
                    <Skeleton
                        key={item}
                        className="gallery-thumbnail"
                    />
                ))}

            </div>

        </div>
    );
}

function ProductPriceSkeleton() {
    return (
        <div className="product-price-skeleton">

            <Skeleton className="price-old" />

            <Skeleton className="price-current" />

            <Skeleton className="price-installment" />

        </div>
    );
}

function ProductBadgesSkeleton() {
    return (
        <div className="product-badges-skeleton">

            <Skeleton className="badge" />
            <Skeleton className="badge" />
            <Skeleton className="badge short" />

        </div>
    );
}

function VariationSelectorSkeleton() {
    return (
        <div className="variation-selector-skeleton">

            <Skeleton className="variation-title" />

            <div className="variation-options">

                {[1, 2, 3].map((item) => (
                    <Skeleton
                        key={item}
                        className="variation-option"
                    />
                ))}

            </div>

        </div>
    );
}

function ProductInfoSkeleton() {
    return (
        <div className="product-info-skeleton">

            {/* Brand */}
            <Skeleton className="product-brand" />

            {/* Product title */}
            <div className="product-title-skeleton">

                <Skeleton />
                <Skeleton />
                <Skeleton className="short" />

            </div>

            {/* Rating */}
            <div className="product-rating-skeleton">

                <Skeleton className="rating-stars" />
                <Skeleton className="rating-count" />

            </div>

            {/* Description */}
            <div className="product-short-description">

                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton className="short" />

            </div>

        </div>
    );
}

function AttributesSkeleton() {
    return (
        <div className="attributes-skeleton">

            <Skeleton className="attributes-title" />

            {[1, 2, 3, 4, 5].map((item) => (
                <div
                    className="attribute-row-skeleton"
                    key={item}
                >

                    <Skeleton className="attribute-name" />

                    <Skeleton className="attribute-value" />

                </div>
            ))}

        </div>
    );
}

function ProductTabsSkeleton() {
    return (
        <section className="product-tabs-skeleton">

            <div className="tabs-header-skeleton">

                {[1, 2, 3, 4].map((item) => (
                    <Skeleton
                        key={item}
                        className="tab-skeleton"
                    />
                ))}

            </div>

            <div className="tabs-content-skeleton">

                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton className="short" />

            </div>

        </section>
    );
}

function ProductCommentsSkeleton() {
    return (
        <section className="comments-skeleton">

            <Skeleton className="comments-title" />

            <div className="comments-content">

                <div className="rating-summary-skeleton">

                    <Skeleton className="rating-number" />
                    <Skeleton className="rating-stars-large" />

                </div>

                <div className="comment-lines">

                    <Skeleton />
                    <Skeleton />
                    <Skeleton className="short" />

                </div>

            </div>

            <div className="comment-item-skeleton">

                <Skeleton className="comment-avatar" />

                <div className="comment-body">

                    <Skeleton className="comment-user" />

                    <Skeleton className="comment-text" />
                    <Skeleton className="comment-text" />
                    <Skeleton className="comment-text short" />

                </div>

            </div>

        </section>
    );
}

function RelatedProductsSkeleton() {
    return (
        <section className="related-section-skeleton">

            <Skeleton className="related-title" />

            <div className="related-products-grid">

                {[1, 2, 3, 4].map((item) => (
                    <div
                        className="related-product-card"
                        key={item}
                    >

                        <Skeleton className="related-product-image" />

                        <Skeleton className="related-product-brand" />

                        <Skeleton className="related-product-name" />
                        <Skeleton className="related-product-name short" />

                        <Skeleton className="related-product-price" />

                    </div>
                ))}

            </div>

        </section>
    );
}

function RelatedArticlesSkeleton() {
    return (
        <section className="related-section-skeleton">

            <Skeleton className="related-title" />

            <div className="related-articles-grid">

                {[1, 2, 3].map((item) => (
                    <div
                        className="related-article-card"
                        key={item}
                    >

                        <Skeleton className="article-image" />

                        <Skeleton className="article-title" />
                        <Skeleton className="article-title short" />

                        <Skeleton className="article-date" />

                    </div>
                ))}

            </div>

        </section>
    );
}


/* =========================================================
   MAIN COMPONENT
========================================================= */

export default function ProductPageSkeleton() {

    return (
        <div
            className="product-page-skeleton"
            dir="rtl"
        >

            {/* =========================================
                BREADCRUMB
            ========================================= */}

            <div className="skeleton-breadcrumb">

                <Skeleton className="breadcrumb-item" />

                <span>/</span>

                <Skeleton className="breadcrumb-item short" />

                <span>/</span>

                <Skeleton className="breadcrumb-item medium" />

            </div>


            {/* =========================================
                PRODUCT
            ========================================= */}

            <div className="product-container-skeleton">

                <div className="product-layout-skeleton">


                    {/* =================================
                        GALLERY
                    ================================= */}

                    <div className="product-gallery">

                        <ProductGallerySkeleton />

                    </div>


                    {/* =================================
                        BUY SECTION
                    ================================= */}

                    <div className="product-buy">


                        {/* Price */}

                        <ProductPriceSkeleton />


                        {/* Badges */}

                        <ProductBadgesSkeleton />


                        {/* Variations */}

                        <VariationSelectorSkeleton />


                        {/* Add cart button */}

                        <Skeleton className="add-cart-button" />


                        {/* Shipping / additional information */}

                        <div className="buy-information">

                            <div>
                                <Skeleton className="info-icon" />

                                <Skeleton className="info-text" />
                            </div>

                            <div>
                                <Skeleton className="info-icon" />

                                <Skeleton className="info-text" />
                            </div>

                            <div>
                                <Skeleton className="info-icon" />

                                <Skeleton className="info-text" />
                            </div>

                        </div>


                    </div>


                    {/* =================================
                        PRODUCT INFO
                    ================================= */}

                    <div className="product-info">

                        <ProductInfoSkeleton />

                        <AttributesSkeleton />

                    </div>

                </div>


                {/* =====================================
                    TABS
                ===================================== */}

                <ProductTabsSkeleton />


                {/* =====================================
                    COMMENTS
                ===================================== */}

                <ProductCommentsSkeleton />


                {/* =====================================
                    RELATED PRODUCTS
                ===================================== */}

                <RelatedProductsSkeleton />


                {/* =====================================
                    RELATED ARTICLES
                ===================================== */}

                <RelatedArticlesSkeleton />

            </div>

        </div>
    );
}